import { ChannelTypeEnum } from "../types";
import { wsHandler } from "../handler/mail/ws-handler";
import chatSdkHooks from "../hooks";
import { WebSocketClient } from "./ws";
import {
  MAIL_ACCOUNT_WS_ADDRESS,
  MAIL_CHAT_WS_ADDRESS,
  MAIL_CONTACT_WS_ADDRESS,
} from "../constants/mail";

export const mailAccountWsClient = new WebSocketClient({
  wsAddress: MAIL_ACCOUNT_WS_ADDRESS,
  onConnectStatusChange: (status) =>
    chatSdkHooks.common.wsConnectStatusChangeHook.emit({
      channelType: ChannelTypeEnum.Email,
      status,
    }),
  onMessage: wsHandler,
  onSendMessageError: (data) => chatSdkHooks.common.sendMessageError.emit(data),
  onError: (data) =>
    chatSdkHooks.common.wsErrorHook.emit({
      channelType: ChannelTypeEnum.Email,
      ...data,
    }),
  onAutoReconnectionFailed: (path, connectParams) => {
    chatSdkHooks.common.autoReconnectionFailedHook.emit({
      path,
      connectParams,
    });
  },
});

export const mailChatWsClient = new WebSocketClient({
  wsAddress: MAIL_CHAT_WS_ADDRESS,
  onConnectStatusChange: (status) =>
    chatSdkHooks.common.wsConnectStatusChangeHook.emit({
      channelType: ChannelTypeEnum.Email,
      status,
    }),
  onMessage: wsHandler,
  onSendMessageError: (data) => chatSdkHooks.common.sendMessageError.emit(data),
  onError: (data) =>
    chatSdkHooks.common.wsErrorHook.emit({
      channelType: ChannelTypeEnum.Email,
      ...data,
    }),
  onAutoReconnectionFailed: (path, connectParams) => {
    chatSdkHooks.common.autoReconnectionFailedHook.emit({
      path,
      connectParams,
    });
  },
});

export const mailContactWsClient = new WebSocketClient({
  wsAddress: MAIL_CONTACT_WS_ADDRESS,
  onConnectStatusChange: (status) =>
    chatSdkHooks.common.wsConnectStatusChangeHook.emit({
      channelType: ChannelTypeEnum.Email,
      status,
    }),
  onMessage: wsHandler,
  onSendMessageError: (data) => chatSdkHooks.common.sendMessageError.emit(data),
  onError: (data) =>
    chatSdkHooks.common.wsErrorHook.emit({
      channelType: ChannelTypeEnum.Email,
      ...data,
    }),
  onAutoReconnectionFailed: (path, connectParams) => {
    chatSdkHooks.common.autoReconnectionFailedHook.emit({
      path,
      connectParams,
    });
  },
});
